/** Minimum delay before attempting Tidy persist (debounce + allow first ELK frame). */
export const TIDY_SAVE_DELAY_MS = 480;
/** After that delay, wait for ELK (elkPositionsOk) before writing customPositions / DB. */
export const TIDY_ELK_WAIT_MAX_MS = 15000;
